module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "author"
    }
  }, [_c('strong', [_vm._v("Author’s Note")])])]), _c('a', {
    attrs: {
      "id": "author"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Navaho healing ceremonials, commonly known as “sings,” are properly called “Ways,” because of the precise manner in which they must be conducted. In these ceremonies, or ways, myth-dramas are acted out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the more popular rites is Night Way. In it, Changing Woman (comparable to Mother Nature), who gave birth to the Navaho race, tried to create light in a world of darkness. On the floor of the hogan, she made a dry-painting: white first for dawn; on it, blue for morning; on the blue, yellow for sunset; and, finally, black for night on the yellow. She prayed but no light came.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She added turquoise and white shell beads. After her prayers, a faint light appeared. The twelve Holy People came to help, bringing more turquoise and shell beads to make a magic circle. Changing Woman held a crystal above it. A bright blaze appeared, but it was so hot and bright, they had to keep raising it and moving it to keep it at a safe distance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this way, light was created.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "author"
    }
  }, [_vm._v("There are some 570 “songs” in Night Way. The verses quoted from selected “songs,” beginning each part of this book, are from translations by Washington Matthews, a noted authority on the Navahos.")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53431d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/author.vue
// module id = 75
// module chunks = 0